import React from 'react';
import { MapPin, Waves, ChevronRight, Star, Camera, BadgeCheck } from 'lucide-react';
import { motion } from 'framer-motion';
import { DIFFICULTY_COLORS, ReactionButtons, SpotMeta } from './constants';

export default function SpotCard({ spot, isStarred, myReaction, onStar, onReact, onClick }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      className="w-full bg-bg-subtle/50 border border-white/5 rounded-2xl p-4"
      data-testid={`spot-${spot.name.replace(/\s+/g, '-').toLowerCase()}`}
    >
      <div className="flex items-center gap-3">
        <button onClick={() => onClick(spot)} className="flex items-center gap-3 flex-1 min-w-0 text-left hover:opacity-80 transition-opacity">
          <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Waves className="w-5 h-5 text-primary" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-1.5">
              <p className="text-sm font-medium truncate">{spot.name}</p>
              {spot.verified && (
                <span className="relative group flex-shrink-0" data-testid={`verified-badge-${spot.name.replace(/\s+/g, '-').toLowerCase()}`}>
                  <BadgeCheck className="w-4 h-4 text-amber-400 drop-shadow-[0_0_3px_rgba(251,191,36,0.4)]" />
                  <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1.5 px-2 py-1 text-[9px] font-medium bg-amber-400/90 text-black rounded-md whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
                    Community Verified
                  </span>
                </span>
              )}
              {spot.source === 'spitcast' && (
                <span className="text-[8px] px-1.5 py-0.5 rounded bg-primary/15 text-primary flex-shrink-0">Spitcast</span>
              )}
              {spot.source === 'community' && (
                <span className="text-[8px] px-1.5 py-0.5 rounded bg-purple-500/15 text-purple-400 flex-shrink-0">community</span>
              )}
              {spot.source === 'seed' && (
                <span className="text-[8px] px-1.5 py-0.5 rounded bg-blue-500/15 text-blue-400 flex-shrink-0">Seed</span>
              )}
              {spot.SLS_has_cam && (
                <Camera className="w-3 h-3 text-muted-foreground/40 flex-shrink-0" title="Webcam available" />
              )}
            </div>
            <p className="text-[10px] text-muted-foreground flex items-center gap-1 mt-0.5">
              <MapPin className="w-2.5 h-2.5" />{spot.region || `${spot.lat?.toFixed(2)}, ${spot.lon?.toFixed(2)}`}
            </p>
          </div>
          <div className="flex flex-col items-end gap-1 flex-shrink-0">
            {spot.difficulty && (
              <span className={`text-[9px] px-2 py-0.5 rounded-md font-medium ${DIFFICULTY_COLORS[spot.difficulty] || DIFFICULTY_COLORS.all}`}>
                {spot.difficulty}
              </span>
            )}
            <ChevronRight className="w-4 h-4 text-muted-foreground/40" />
          </div>
        </button>
      </div>
      <div className="flex items-center justify-between mt-2 pt-2 border-t border-white/5 pl-[52px]">
        <ReactionButtons spotName={spot.name} myReaction={myReaction} onReact={onReact} />
        <SpotMeta lat={spot.lat} lon={spot.lon} name={spot.name} />
        <button
          data-testid={`star-${spot.name.replace(/\s+/g, '-').toLowerCase()}`}
          onClick={(e) => { e.stopPropagation(); onStar(spot.name); }}
          className="p-1.5 rounded-xl hover:bg-white/5 transition-colors"
        >
          <Star className={`w-4 h-4 transition-all ${isStarred ? 'text-yellow-400 fill-yellow-400' : 'text-muted-foreground/30'}`} />
        </button>
      </div>
    </motion.div>
  );
}
